import React, { useEffect, useState } from 'react';
import { Form, Input, Modal, Select } from 'antd';
import { createAdminServiceFee, updateAdminServiceFee } from '../../../../api';
import 'vditor/dist/index.css';
import '../../style.vditor.scss';

import { messageError, messageSuccess } from '../../../../components/message';
import getFormatMessage from '../../../../locales/get-format-message';
import {
  IServiceFeeModelResItem,
  ServiceFeeScriptType,
  ServiceFeeModel,
} from '../../../../model/api-modules/price-calculator';

import { CodeEditor } from './code-edit';
import { CommonStatusStep } from '../../../../model/api-modules';
// import { getLangFormatText, LanguageType } from '../../../lib';

interface IProps {
  readonly setShowCreateModal: (value: boolean) => void;
  readonly getPaymentModelList: () => void;
  readonly currentRecord: IServiceFeeModelResItem | null;
  readonly setCurrentRecord: (value: IServiceFeeModelResItem | null) => void;
}

interface IOption {
  readonly value: string;
  readonly label: string;
}

export const CreateModelSetting = (props: IProps) => {
  const [loading, setLoading] = useState<boolean>(false);

  const [form] = Form.useForm();

  useEffect(() => {
    if (props.currentRecord) {
      form.setFieldsValue({
        ModelName: props.currentRecord.ModelName,
        ModelRelationServices: props.currentRecord.ModelRelationServices,
        ComputeScriptStr: props.currentRecord.ComputeScriptStr,
      });
    }
  }, [props.currentRecord]);

  const onCancel = () => {
    props.setShowCreateModal(false);
  };

  const onOk = async () => {
    const values = form.getFieldsValue();
    if (!values.ModelName) {
      return messageError(getFormatMessage('please_enter_model_name'));
    }
    if (!values.ModelRelationServices) {
      return messageError(getFormatMessage('please_select_cost_items'));
    }
    if (!values.ComputeScriptStr) {
      return messageError(getFormatMessage('please_enter_cost_script'));
    }
    if (props.currentRecord) {
      const res = await updateAdminServiceFee(props.currentRecord.id, {
        ModelName: props.currentRecord.ModelName,
        ModelRelationServices: props.currentRecord.ModelRelationServices,
        ComputeScriptStr: props.currentRecord.ComputeScriptStr,
        ScriptType: props.currentRecord.ScriptType,
        Status: props.currentRecord.Status,
        ...values,
      });
      setLoading(false);
      if (res === 0) {
        props.getPaymentModelList();
        props.setShowCreateModal(false);
        messageSuccess(getFormatMessage('edit_success'));
        return;
      }
      messageError(getFormatMessage('error_update'));
      return;
    }
    const res = await createAdminServiceFee({
      ...values,
      ModelRelationServices: values.ModelRelationServices,
      ScriptType: ServiceFeeScriptType.JS,
      Status: CommonStatusStep.Pending,
    });
    setLoading(false);
    if (res === 0) {
      props.getPaymentModelList();
      props.setShowCreateModal(false);
      messageSuccess(getFormatMessage('create_success'));
      return;
    }
    messageError(getFormatMessage('create_fail'));
  };

  const options: IOption[] = [];
  for (const [key, value] of Object.entries(ServiceFeeModel)) {
    options.push({
      label: key,
      value,
    });
  }

  return (
    <Modal
      title={
        props.currentRecord
          ? getFormatMessage('edit')
          : getFormatMessage('create')
      }
      open={true}
      style={{ width: '715px' }}
      onCancel={onCancel}
      maskClosable={false}
      onOk={onOk}
      okText={
        props.currentRecord
          ? getFormatMessage('edit')
          : getFormatMessage('create')
      }
      confirmLoading={loading}
      className="download-news-modal"
    >
      <Form
        name="basic"
        className="admin-form"
        form={form}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 17 }}
        style={{ maxWidth: 850 }}
        autoComplete="off"
      >
        <Form.Item
          label={getFormatMessage('model_name')}
          name="ModelName"
          rules={[
            {
              required: true,
              message: getFormatMessage('please_enter_model_name'),
            },
          ]}
        >
          <Input placeholder={getFormatMessage('please_enter_model_name')} />
        </Form.Item>
        <Form.Item
          label={getFormatMessage('cost_items')}
          name="ModelRelationServices"
          rules={[
            {
              required: true,
              message: getFormatMessage('please_select_cost_items'),
            },
          ]}
        >
          <Select
            placeholder={getFormatMessage('please_select_cost_items')}
            mode="multiple"
            options={options}
          />
        </Form.Item>
        <Form.Item
          label={getFormatMessage('cost_script')}
          name="ComputeScriptStr"
          rules={[
            {
              required: true,
              message: getFormatMessage('please_enter_cost_script'),
            },
          ]}
        >
          <CodeEditor />
        </Form.Item>
      </Form>
    </Modal>
  );
};
